var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.565,
    height: 25.207,
    viewBox: "0 0 28.565 25.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6a709f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.1,45.275A4.7,4.7,0,0,1,14.61,41.1,7.246,7.246,0,0,0,12.3,40.73h0A7.3,7.3,0,0,0,5,48.03v1.323a12.378,12.378,0,0,0,6.786,2.355A7.586,7.586,0,0,1,18.1,45.275Z",
    transform: "translate(-5 -31.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.018,14.587a4.294,4.294,0,1,0-1.5,3.247,4.735,4.735,0,0,1,1.07-1.393,4.275,4.275,0,0,0,.428-1.854Z",
    transform: "translate(-11.436 -10.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.556,40.73h0a7.214,7.214,0,0,0-2.295.371,4.71,4.71,0,0,1-3.491,4.174,7.592,7.592,0,0,1,6.3,6.433,12.378,12.378,0,0,0,6.789-2.361V48.03A7.3,7.3,0,0,0,59.556,40.73Z",
    transform: "translate(-38.291 -31.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62.791,18.882a4.291,4.291,0,1,0-3.856-2.428,4.732,4.732,0,0,1,1.073,1.4A4.266,4.266,0,0,0,62.791,18.882Z",
    transform: "translate(-41.526 -10.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.107,56.76h-.048a6.948,6.948,0,0,0-6.909,6.935v1.27a11.81,11.81,0,0,0,13.87,0v-1.27a6.948,6.948,0,0,0-6.913-6.935Z",
    transform: "translate(-20.803 -42.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.8,36.257a4.245,4.245,0,0,0,.451.025,3.593,3.593,0,0,0,.454-.029,4.066,4.066,0,0,0,3.561-3.406,4.177,4.177,0,0,0,.054-.635,4.069,4.069,0,0,0-8.135,0,3.809,3.809,0,0,0,.054.635A4.066,4.066,0,0,0,40.8,36.257Z",
    transform: "translate(-26.967 -22.552)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.dbfd9cf50ba831cbe479c9ceb1d303b0.svg";
export { ForwardRef as ReactComponent };